import { get } from "lodash";
import styled from "styled-components";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers";

import { TextField } from "./index";
import { colors } from "../pages/css components/Style";

const DateTimePicker = styled(MuiDateTimePicker)`
  .MuiTextField-root {
    padding: 8px;
    border-color: #909090 !important;
  }

  & label.Mui-focused {
    color: ${colors.purple};
  }

  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: ${colors.purple};
    }
  }

  .MuiInputLabel-root {
    color: #333;
  }

  .MuiOutlinedInput-notchedOutline {
    border-radius: 5px;
  }

  .MuiOutlinedInput-root {
    font-size: 16px;
    // border-color: ${colors.purple};
    border-radius: 5px;
  }

  .Mui-disabled {
    color: rgba(0, 0, 0, 0.66);
    font-size: 16px;
    border-radius: 5px;
    -webkit-text-fill-color: rgba(0, 0, 0, 0.66);
  }

  .MuiInputLabel-outlined {
    font-size: 16px;
  }

  .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: #f5f5f5;
    border: 1px solid #c4cacb;
  }

  #mui-7-helper-text {
    color: red;
  }
  .MuiInputLabel-asterisk {
    color: ${(props) => (Boolean(props.required && !props.value) ? "red" : "")};
  }
`;
export default function MUIDateTimePicker({
  formikProps,
  alternate,
  ...props
}) {
  const isFilled = !!get(formikProps.values, props.name, "");

  return (
    <DateTimePicker
      {...props}
      required
      name={props.name}
      formikProps={formikProps}
      label={props.label}
      minDateTime={props.minDateTime}
      value={
        get(formikProps.values, props.name, "")
          ? new Date(get(formikProps.values, props.name, ""))
          : get(formikProps.values, props.name, "")
      }
      ampm
      closeOnSelect={false}
      inputProps={{ readOnly: true }}
      onChange={(newValue) => {
        let n = String(props.name).split(".")[0];
        formikProps.setValues((prevVal) => ({
          ...prevVal,
          [n]: { value: newValue },
          [alternate]: newValue,
        }));
      }}
      sx={{ width: "100%" }}
      slotProps={{
        textField: {
          size: "small",
          required: true,
          error:
            !!get(formikProps.touched, props.name) &&
            !!get(formikProps.errors, props.name),

          helperText:
            !!get(formikProps.touched, props.name) &&
            get(formikProps.errors, props.name),
          sx: {
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: isFilled ? colors.purple : colors.greyBorder,
              },
              "&:hover fieldset": {
                borderColor: isFilled ? colors.purple : colors.greyBorder,
              },
              "&.Mui-focused fieldset": {
                borderColor: colors.purple,
                borderWidth: 2,
              },
              "&.Mui-error": {
                borderColor: isFilled
                  ? `${colors.purple}!important`
                  : `${colors.greyBorder}!important`,
              },
            },
          },
        },
      }}
      renderInput={(params) => (
        <TextField
          required
          autoComplete="off"
          label={props.label}
          name={props.name}
          formikProps={formikProps}
          {...params}
        />
      )}
    />
  );
}
